// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "lazy-pxModal" + "." + "8a7bf3537410cf1888df" + ".js";
};